import $ from 'jquery'
import gsap from 'gsap'

const TRIGGER_SELECTOR = '.news-list__toggle button'
const CONTAINER_SELECTOR = '.news-list__container'
const CONTENT_SELECTOR = '.news-list__row'
const IS_COLLAPSIBLE_CLASS = 'news-list--is-collapsible'
const ACTIVE_CLASS = 'news-list--open'

class NewsLists {
  constructor(selector = '.news-list') {
    this.items = $(selector)
    this.init()
  }

  init() {
    this.items.each((index, item) => new NewsList(item))
  }
}

class NewsList {
  constructor(item) {
    this.item = $(item)
    this.items = $('.news-list__item:nth-child(n + 4)', item)
    this.container = $(CONTAINER_SELECTOR, item)
    this.content = $(CONTENT_SELECTOR, item)
    this.trigger = $(TRIGGER_SELECTOR, item)

    this.isCollapsible = this.item.hasClass(IS_COLLAPSIBLE_CLASS) && this.items

    if (!this.isCollapsible) {
      return
    }

    this.listen()
  }

  listen() {
    this.trigger.on('click', () => {
      event.preventDefault()
      this.activate()
    })
  }

  activate() {
    this.container.css('height', this.content.height())
    this.item.addClass(ACTIVE_CLASS)

    // animate stuff
    gsap.to(this.trigger, {
      duration: 0.2,
      opacity: 0,
      ease: 'sine.inOut',
      onComplete: () => {
        this.trigger.hide()
      },
    })

    gsap.to(this.container, {
      duration: 0.3,
      height: this.content.height(),
      ease: 'sine.inOut',
      onComplete: () => {
        this.container.css('height', '')
      },
    })

    gsap.to(this.items, {
      duration: 0.3,
      delay: 0.1,
      opacity: 1,
      stagger: 0.1,
      ease: 'sine.inOut',
    })

    this.isActive = !this.isActive
  }
}

export default NewsLists
